import { BaseDto } from "@/shared/dtos/base-dto";

export class dispositivo extends BaseDto {
  public nombre!: string;
  public localizacion!: string;
  public nombre_calle!: string;
}
